import React from "react";

const MathBlock = ({ block }) => {
    return (
        <div
            style={{
                margin: "20px 0",
                textAlign: "center",
                fontFamily: "serif",
                fontSize: 24,
                whiteSpace: "pre-wrap",
            }}
        >
            {block.latex || ""}
        </div>
    );
};

export default MathBlock;